import { render, staticRenderFns } from "./HeaderBlack.vue?vue&type=template&id=70fb56ed&"
import script from "./HeaderBlack.vue?vue&type=script&lang=js&"
export * from "./HeaderBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports